"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreemApiCallLogEntryCallStatus = exports.StreemApiCallLogEntryToJSON = exports.StreemApiCallLogEntryFromJSONTyped = exports.StreemApiCallLogEntryFromJSON = void 0;
const runtime_1 = require("../runtime");
const _1 = require("./");
function StreemApiCallLogEntryFromJSON(json) {
    return StreemApiCallLogEntryFromJSONTyped(json, false);
}
exports.StreemApiCallLogEntryFromJSON = StreemApiCallLogEntryFromJSON;
function StreemApiCallLogEntryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'roomSid': !(0, runtime_1.exists)(json, 'room_sid') ? undefined : json['room_sid'],
        'startTime': !(0, runtime_1.exists)(json, 'start_time') ? undefined : (new Date(json['start_time'])),
        'endTime': !(0, runtime_1.exists)(json, 'end_time') ? undefined : (new Date(json['end_time'])),
        'participants': !(0, runtime_1.exists)(json, 'participants') ? undefined : (json['participants'].map(_1.StreemApiCallLogParticipantFromJSON)),
        'missed': !(0, runtime_1.exists)(json, 'missed') ? undefined : json['missed'],
        'onsite': !(0, runtime_1.exists)(json, 'onsite') ? undefined : json['onsite'],
        'artifactCounts': !(0, runtime_1.exists)(json, 'artifact_counts') ? undefined : (0, _1.StreemApiArtifactCountsFromJSON)(json['artifact_counts']),
        'shareUrl': !(0, runtime_1.exists)(json, 'share_url') ? undefined : json['share_url'],
        'referenceId': !(0, runtime_1.exists)(json, 'reference_id') ? undefined : json['reference_id'],
        'createdByUserSid': !(0, runtime_1.exists)(json, 'created_by_user_sid') ? undefined : json['created_by_user_sid'],
        'note': !(0, runtime_1.exists)(json, 'note') ? undefined : (0, _1.StreemApiNoteFromJSON)(json['note']),
        'latestGpsPosition': !(0, runtime_1.exists)(json, 'latest_gps_position') ? undefined : (0, _1.StreemApiArtifactGpsPositionFromJSON)(json['latest_gps_position']),
        'invitations': !(0, runtime_1.exists)(json, 'invitations') ? undefined : (json['invitations'].map(_1.StreemApiCallLogRoomInvitationFromJSON)),
        'favorite': !(0, runtime_1.exists)(json, 'favorite') ? undefined : json['favorite'],
        'integrationId': !(0, runtime_1.exists)(json, 'integration_id') ? undefined : json['integration_id'],
        'callStatus': !(0, runtime_1.exists)(json, 'call_status') ? undefined : json['call_status'],
        'canceledCallRingTimeInSecs': !(0, runtime_1.exists)(json, 'canceled_call_ring_time_in_secs') ? undefined : json['canceled_call_ring_time_in_secs'],
        'callDuration': !(0, runtime_1.exists)(json, 'call_duration') ? undefined : (0, _1.GoogleProtobufDurationFromJSON)(json['call_duration']),
    };
}
exports.StreemApiCallLogEntryFromJSONTyped = StreemApiCallLogEntryFromJSONTyped;
function StreemApiCallLogEntryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'room_sid': value.roomSid,
        'start_time': value.startTime === undefined ? undefined : (value.startTime.toISOString()),
        'end_time': value.endTime === undefined ? undefined : (value.endTime.toISOString()),
        'participants': value.participants === undefined ? undefined : (value.participants.map(_1.StreemApiCallLogParticipantToJSON)),
        'missed': value.missed,
        'onsite': value.onsite,
        'artifact_counts': (0, _1.StreemApiArtifactCountsToJSON)(value.artifactCounts),
        'share_url': value.shareUrl,
        'reference_id': value.referenceId,
        'created_by_user_sid': value.createdByUserSid,
        'note': (0, _1.StreemApiNoteToJSON)(value.note),
        'latest_gps_position': (0, _1.StreemApiArtifactGpsPositionToJSON)(value.latestGpsPosition),
        'invitations': value.invitations === undefined ? undefined : (value.invitations.map(_1.StreemApiCallLogRoomInvitationToJSON)),
        'favorite': value.favorite,
        'integration_id': value.integrationId,
        'call_status': value.callStatus,
        'canceled_call_ring_time_in_secs': value.canceledCallRingTimeInSecs,
        'call_duration': (0, _1.GoogleProtobufDurationToJSON)(value.callDuration),
    };
}
exports.StreemApiCallLogEntryToJSON = StreemApiCallLogEntryToJSON;
/**
* @export
* @enum {string}
*/
var StreemApiCallLogEntryCallStatus;
(function (StreemApiCallLogEntryCallStatus) {
    StreemApiCallLogEntryCallStatus["SUCCESSFUL"] = "STATUS_SUCCESSFUL";
    StreemApiCallLogEntryCallStatus["CANCELED"] = "STATUS_CANCELED";
    StreemApiCallLogEntryCallStatus["REJECTED"] = "STATUS_REJECTED";
    StreemApiCallLogEntryCallStatus["TIMEDOUT"] = "STATUS_TIMED_OUT";
    StreemApiCallLogEntryCallStatus["INVALID"] = "STATUS_INVALID";
})(StreemApiCallLogEntryCallStatus = exports.StreemApiCallLogEntryCallStatus || (exports.StreemApiCallLogEntryCallStatus = {}));
//# sourceMappingURL=StreemApiCallLogEntry.js.map